import React, { useState, useEffect } from 'react';
import { Routes, Route, Link, useNavigate } from 'react-router-dom';
import LoginForm from './components/LoginForm';
import SignupForm from './components/SignupForm';
import HiFiSetupForm from './components/HiFiSetupForm';
import MapView from './components/MapView';
import ProtectedRoute from './components/ProtectedRoute';
import HearingRequestForm from './components/HearingRequestForm';
import ReportProblemButton from './components/ReportProblemButton';
import ProfileSettings from './components/ProfileSettings';
import ImageUpload from './components/ImageUpload';
import InfoModal from './components/InfoModal';
// Import Marketplace Components
import MarketplaceOverview from './components/MarketplaceOverview';
import MarketplaceList from './components/MarketplaceList';
import MarketplaceDetail from './components/MarketplaceDetail';
import MarketplaceForm from './components/MarketplaceForm';
import Impressum from './components/Impressum';
// Import HiFi Review Board component
import HiFiReviewBoard from './components/HiFiReviewBoard';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
// password reset
import ForgotPasswordForm from './components/ForgotPasswordForm';
import ResetPasswordForm from './components/ResetPasswordForm';


function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const navigate = useNavigate();
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);

  useEffect(() => {
    const checkAuth = () => {
      const token = localStorage.getItem('token');
      if (token) {
        // Validieren Sie den Token und setzen Sie userId
        try {
          // Versuchen Sie, die Benutzer-ID aus dem Token oder localStorage zu extrahieren
          const userData = JSON.parse(localStorage.getItem('user') || '{}');
          if (userData && userData.id) {
            localStorage.setItem('userId', String(userData.id));
          }
        } catch (e) {
          console.error('Fehler bei der Token-Validierung:', e);
        }
        setIsAuthenticated(true);
      } else {
        setIsAuthenticated(false);
      }
    };
    
    checkAuth();
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setIsAuthenticated(false);
    navigate('/');
  };

  return (
    <div className="App">
      <header>
        <h1>HiFiCouch.World</h1>
        <nav className="navbar">
          <Link to="/">Home</Link>
          {' '}| <Link to="/marketplace">Gebrauchtmarkt</Link>
          {' '}| <Link to="/reviews" className="nav-link">
            <span className="material-symbols-outlined">rate_review</span>
            HiFi Reviews
          </Link>
          {isAuthenticated && (
            <>
              {' '}| <Link to="/hifiSetups">HIFI Setups</Link>
              {' '}| <Link to="/profile">Profil</Link>
              {' '}| <Link to="/upload">Upload</Link>
              {' '}| <button onClick={handleLogout} style={{
                background: 'none',
                border: 'none',
                padding: 0,
                color: '#0078d4',
                textDecoration: 'underline',
                cursor: 'pointer'
              }}>Logout</button>
            </>
          )}
          {!isAuthenticated && (
            <>
              {' '}| <Link to="/login">Login</Link>
              {' '}| <Link to="/signup">Registrieren</Link>
            </>
          )}
          <Link to="#" style={{ textDecoration: 'none' }}><ReportProblemButton inMenu={true} /> </Link> |{' '}
          <Link to="/impressum" className="nav-link" title="Impressum">
            <button className="info-button">
              <span className="material-symbols-outlined">gavel</span>
            </button>
          </Link>
          <button onClick={() => setIsInfoModalOpen(true)} className="info-button">
            <span className="material-symbols-outlined">chat_info</span>
          </button>
        </nav>
      </header>
      <main>
        <Routes>
          <Route path="/" element={<MapView />} />
          <Route path="/hearing-request" element={<HearingRequestForm />} />
          <Route path="/forgot-password" element={<ForgotPasswordForm />} />
          <Route path="/reset-password" element={<ResetPasswordForm />} />
          {!isAuthenticated && (
            <Route path="/login" element={<LoginForm setAuth={setIsAuthenticated} />} />
          )}
          <Route path="/signup" element={<SignupForm />} />
          <Route
            path="/hifiSetups"
            element={
              <ProtectedRoute>
                <HiFiSetupForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <ProfileSettings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/upload"
            element={
              <ProtectedRoute>
                <ImageUpload />
              </ProtectedRoute>
            }
          />
          {/* Marketplace Routes */}
          <Route path="/marketplace" element={<MarketplaceList />} />
          <Route path="/marketplace/list" element={<MarketplaceList />} />
          <Route 
            path="/marketplace/new" 
            element={
              <ProtectedRoute>
                <MarketplaceForm />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/marketplace/edit/:id"
            element={
              <ProtectedRoute>
                <MarketplaceForm />
              </ProtectedRoute>
            } 
          />
          <Route path="/marketplace/:id" element={<MarketplaceDetail />} />
          <Route 
            path="/marketplace/my-listings" 
            element={
              <ProtectedRoute>
                <MarketplaceList />
              </ProtectedRoute>
            } 
          />

          {/* Add this new route */}
          <Route 
            path="/reviews" 
            element={
              <ProtectedRoute>
                <HiFiReviewBoard />
              </ProtectedRoute>
            } 
          />
                <Route path="/impressum" element={<Impressum />} />
        </Routes>
      </main>
      <InfoModal isOpen={isInfoModalOpen} onClose={() => setIsInfoModalOpen(false)} />
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
}

export default App;
